module.exports = __webpack_public_path__ + "static/media/my-info-menu-icon.8fc151ef.svg";